export const DEFAULT_MESSAGE_DURATION = 5;
export const EMPTY_ARRAY = [];
export const EMPTY_OBJECT = {};
